import {
  ExclamationCircleOutlined,
  PlusCircleOutlined,
} from '@ant-design/icons';
import { Button, message, Modal, Tooltip } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import { DevicesAPI } from 'api/DevicesAPI';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { PartnerHigoDevice } from 'models/higoDevice';
import React, { FC, ReactNode } from 'react';
import { useMutation } from 'react-query';

interface GenerateDeviceTokenButtonProps
  extends Omit<ButtonProps, 'onClick' | 'loading' | 'href'> {
  device: PartnerHigoDevice;
  tooltip: ReactNode;
  onGenerate?: () => void;
}

export const GenerateDeviceTokenButton: FC<GenerateDeviceTokenButtonProps> = ({
  device,
  tooltip,
  onGenerate,
  ...buttonProps
}) => {
  const [mutate, { isLoading }] = useMutation(DevicesAPI.generateDeviceToken);
  const intlMessage = useFormatMessage();

  const showConfirm = () =>
    Modal.confirm({
      title: intlMessage(
        { id: 'devices.generateToken.confirm' },
        { serialNumber: device.serialNumber }
      ),
      icon: <ExclamationCircleOutlined />,
      okText: intlMessage({ id: 'yes' }),
      cancelText: intlMessage({ id: 'cancel' }),
      okType: 'primary',
      onOk: () =>
        mutate(device.id, {
          onSuccess: () => {
            message.success(
              intlMessage({ id: 'devices.generateToken.success' })
            );
            onGenerate && onGenerate();
          },
        }),
    });

  const button = (
    <Button
      id="button-generate-device-token"
      loading={isLoading}
      onClick={showConfirm}
      icon={<PlusCircleOutlined />}
      {...buttonProps}
    />
  );

  return tooltip ? <Tooltip title={tooltip}>{button}</Tooltip> : button;
};
